import { Component, inject, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UserData } from '@core/authentication/user';
import { environment } from '@envs/environment';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-email-verification',
  imports: [],
  templateUrl: './email-verification.component.html',
})
export class EmailVerificationComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly rutaActiva = inject(ActivatedRoute);
  private readonly translate = inject(TranslateService);
  private readonly snackBar = inject(MatSnackBar);
  Email: string;
  urlBase = environment;
  constructor() {
    this.translate.setDefaultLang('es');
    this.Email = this.rutaActiva.snapshot.params['email'];
    localStorage.setItem('email', this.Email);
    const url = this.urlBase.urlFuntionEmailConfirm + this.Email;
    this.snackBar.open(
      this.translate.instant('EmailVerifiedSuccessfully.texto'),
      '',
      {
        duration: 2000,
        panelClass: ['error'],
      }
    );
    this.router.navigate(['']);
  }

  ngOnInit() {}
}
